import moment from 'moment-timezone';
import { standardDeviation, average, handleFormError } from 'assets/js/misc';
import { LogService } from 'ng/src/app/logs/log.service';
import { AppStateService } from 'ng/src/app/core/services/app-state.service'

angular.module('logbook')
  .controller('log-detail', ['$scope', '$rootScope', '$http', '$location', '$window', '$filter', '$route', '$q', '$timeout', '$httpParamSerializer', 'logService', 'logDataService', 'errorHandler', '$uibModal', 'appStateService', 'simulateLogUserRoleService',
      function($scope, $rootScope, $http, $location, $window, $filter, $route, $q, $timeout, $httpParamSerializer, logService, logDataService, errorHandler, uibModal, appStateService, simulateLogUserRoleService) {
     
      var suppressedReport = {id: -1, name: 'No Filter'};
      $scope.userReportMap = {};
      $scope.deliveryChannelUpdates = [];
      $scope.noteDeletionDummyVariable = $scope.selectedLog && AppStateService.isNoteDeletionEnabledForLog($scope.selectedLog.id);
     $scope.initFields = function() {
        $scope.disabled = $scope.selectedLog && $scope.selectedLog.role != 'ADMIN';
        $scope.ready = true;
     };

     $scope.showOldTemplateList = false;
     
	  logService.getLogRoles().subscribe(logRoles => {
		  $scope.logRoles = logRoles;
		  
        logRoles.forEach(logRole => {
           
			if(logRole.id == 1)
			   $scope.readRole = logRole;
		 });
	  });
      
      $scope.newUser = {
            role: $scope.readRole
      };
      
      $scope.readLogDeletionTime = function(log) {
         if( log.deletionScheduledTime )
         {
            try {
               $scope.logDeletionTime = new Date(log.deletionScheduledTime.replace("+0000","Z"));
               $scope.logDeletionTime.setDate($scope.logDeletionTime.getDate() + 1);
            } catch(e) {
               console.log(e);
            }
         }
      };


          if( $scope.selectedLog && $scope.selectedLog.id )
      {
         $http.get('/api/templates', { params : {
               'log': $scope.selectedLog.id,
               'size': 10000
            }}).then(function(result) {
               $scope.templates = result.data._embedded.templates;
            });

          $http.get('/api/reports', { params : {
                  'isPublicViewNotesFilter': true,
                  'activeRevision': true,
                  'log': $scope.selectedLog.id,
                  'size': 10000
              }}).then(function(result) {
                  $scope.reports = result.data._embedded.reports;
                  $scope.userReports = [suppressedReport];
                  $scope.userReports = $scope.userReports.concat($scope.reports);
          });

         $scope.readLogDeletionTime($scope.selectedLog);
      }
      
      
      $scope.validEnterNoteSorts = [
         { id: 'noteTime', desc: 'Note Time'},
         { id: 'maxPriority', desc: 'Priority'},
         { id: 'updatedBy', desc: 'Last Updated By'}
      ];
      
      $scope.validNoteQuerySorts = $scope.validEnterNoteSorts.slice();
      $scope.validNoteQuerySorts.push({'id':'updatedAt', 'desc':'Last Updated At'});
      
      $scope.weekago = new Date();
      $scope.weekago.setDate($scope.weekago.getDate() - 7);
      $scope.weekago = $scope.weekago.toISOString();
      
      $scope.smartTableCtrlContainer = {};
      $scope.matchingItems = {};
      
      $scope.deletionUpdate = $scope.selectedLog && {
            'log': $scope.selectedLog._links.self.href,
            'scheduleDeletion' : true
      };
      
      $scope.unDeletionUpdate = $scope.selectedLog && {
            'log': $scope.selectedLog._links.self.href,
            'scheduleDeletion' : false
      };
      
      $scope.updateUserField = function(user, field, data) {

          // create PATCH json
          var update = {};
          if (field === 'defaultReportObjectFilter')
          {
              if (data && data.id >= 1 && $scope.userReportMap[user.id] && $scope.userReportMap[user.id].find(function(report) { return report.id === data.id; }))
              {
                  update.defaultReportObjectFilter = data.complexObject._links.self.href;
                  update.suppressReportFilter = false;
              }
              else
              {
                  update.defaultReportObjectFilter = null;
                  update.suppressReportFilter = (!!data && data.id <= 0)
              }
          }
          else
              update[field] = ((field === 'role' || field === 'defaultTemplate') && data && data._links) ? data._links.self.href : data;

          // do user setting patch
          return $http.patch(user._links.self.href, update).then(function () {

              // if updating the user's own settings go ahead and replace the current loguser's settings
              if ($scope.isSelf(user) && (typeof data == typeof $scope.selectedLog.activeLogUser[field] || data === null) && (data !== $scope.selectedLog.activeLogUser[field])) {
                  $scope.selectedLog.activeLogUser[field] = data;
              }

              // refresh the users
              $scope.refreshUsers();
          });
      };
      
      $scope.getFriendlyStorageDisplay = function(bytes)
      {
         var res = {};
         if( 1024 > bytes )
            res['num'] = bytes, res['unit'] = "bytes";
         else if( 1024*1024 > bytes )
            res['num'] = bytes/1024, res['unit'] = "kilobytes";
         else if( 1024*1024*1024 > bytes )
            res['num'] = bytes/1024/1024, res['unit'] = "megabytes";
         else res['num']=bytes/1024/1024/1024, res['unit'] = "gigabytes";
         return res;
      };
     
      $scope.refreshUsers = function() {
         var pUsers = $http.get('/api/logUsers?size=1000',
               { params: 
                  {
                     "log" : $scope.selectedLog.id
                  }
               }
            ).then(function(users) {
               $scope.users = users.data._embedded.logUsers;
               $scope.users.forEach(function(user)
               {
                   if (user.suppressReportFilter)
                       user.defaultReportFilter = suppressedReport;
               });
               $scope.numAdmins = 0;
               $scope.users.forEach(function(user) {
                  if( $scope.mapRole(user.role) == 'ADMIN')
                     $scope.numAdmins++;
               });
            });
         
         var pInvitations = $http.get('/api/logInvitations?size=1000',
               { params: 
                  {
                     "log" : $scope.selectedLog.id
                  }
               }
         ).then(function(invitations) {
            $scope.invitations = invitations.data._embedded.logInvitations;
         });
         
         $scope.getDataSeries = function(key, result, value, yaxis)
         {
            return {
               'key' : key,
               'type' : 'line',
               'yAxis' : yaxis,
               'values' : result.data.map(function(d) {
                  var res = {};
                  res['date'] = new Date(d.date);
                  res['value'] = d[value];
                  return res;
                 })};
         }
         
         var userPromises = [pUsers, pInvitations];
         userPromises.push($http.get('/api/logUserIdentifiers?size=1000',
               { params: {
                  "log" : $scope.selectedLog.id
               }}).then(function(result) {
                  $scope.userIdentifiers = {};
                  result.data._embedded.logUserIdentifiers.forEach(function(identifier) {
                     $scope.userIdentifiers[identifier.userId] = identifier.userIdentifier;
                  })
               }));
         $q.all(userPromises).then(function() {
            
            $scope.users.forEach(function(user) {
               user.displayName = user.user.firstName + ' ' + user.user.lastName;
               user.isUser = true;
            });
            
            $scope.invitations.forEach(function(invitation) {
               invitation.displayName =
                  invitation.email 
                     ? invitation.email
                     : (invitation.user.firstName + ' ' + invitation.user.lastName);

               invitation.invitation = true;
            });
            
            $scope.userList = [];
            $scope.userList = $scope.userList.concat($scope.users).concat($scope.invitations);
         });
      };
      
      $scope.chartDays = 30;
      $scope.refreshLogStatistics = function()
      {
         var chartFromDate = new Date();
         chartFromDate.setDate( chartFromDate.getDate() - $scope.chartDays);

         return $http.get('/api/logStatisticsOverTime', {
            params: {
               'log' : $scope.selectedLog.id,
               'timeZone' : moment.tz.guess(),
               'from' : chartFromDate.toISOString(),
               'to' : new Date().toISOString()
            }
         }).then(function(result) {
            $scope.chartData = [
              $scope.getDataSeries('Notes', result, 'numNotes', 1),
              $scope.getDataSeries('Reminders', result, 'numReminders', 1)
              //$scope.getDataSeries('Storage', result, 'numStorageBytes', 2),
            ];
            

            var maxDev = Math.max.apply(null, $scope.chartData.map(function(data) {
               return standardDeviation(data.values.map(function(value) {
                  return value.value;
               } ));
            }));
            var maxAvg = Math.max.apply(null, $scope.chartData.map(function(data) {
               return average(data.values.map(function(value) {
                  return value.value;
               } ));
            }));
            if( maxDev == 0 )
               maxDev=2;
            $scope.chartOptions.chart.yDomain =[0, Math.max(10,Math.ceil(maxAvg + maxDev*3))];
            $scope.chartOptions.chart.xDomain = [chartFromDate, new Date()];

         })
      };

      $scope.hasEvidentAccess = function() {
          let log = $scope.log;
          if (log == null) return false;

          let dueInMs = log.millisToEvidentPaymentExpiration;
          if (dueInMs == null) return false;

          return dueInMs > 0;
      }
      
      $scope.initialLoad = function()
      {
          if( $location.search()['editLog'] )
          {
              var params = {
                  'log': $scope.selectedLog.id,
                  'sort': 'updated,desc',
                  'size': 5
              };
        
              $q.all([
                  $http.get($location.search()['editLog']).then(function(result) {
                      $scope.log = result.data;
                  }),
                  $http.get('/api/logStatistics/' + $scope.selectedLog.id).then(function(result) {
                      $scope.logStatistics = result.data;
                  }),
                  $http.get('/api/notes', {params: params}).then(function(results) {
                      $scope.recentNotes = results.data._embedded.notes;
                      $scope.recentNotesPage = results.data.page;
                  }),
                  $http.get('/api/reminders', {params: params}).then(function(results) {
                      $scope.recentReminders = results.data._embedded.reminders;
                  }),
                  $scope.refreshLogStatistics()
              ]).then(function() {
                  $scope.initFields();
                  $scope.recentActivity = $scope.recentNotes.slice(0).concat($scope.recentReminders.slice(0));
              });
        
              $scope.getReportsByUser = function(logUser)
              {
                  if (!logUser || !logUser.user || !logUser.user.id ) return $q.reject('Could not get user');
                  return $http.get('/api/reports', {
                      params: {
                          log: $scope.selectedLog.id,
                          filtersForUser: logUser.user.id,
                          activeRevision: true,
                          projection: 'reportFilterProjection'
                      }
                  })
                      .then(function(result)
                      {
                          $scope.userReportMap[logUser.id] = [suppressedReport].concat(result.data._embedded.reports);
                      })
              };
        
              $scope.refreshUsers();
          }
          else
          {
              function clickBtn()
              {
                  $timeout(function() {
                      // Check if there is still no selected log before selecting the name edit
                      if (!$location.search()['editLog'])
                          $('#log-name-edit').click();
                  });
              }
              $scope.log = {};
              $scope.initFields();
              var $nameBtn = $('#log-name-edit');
              
              // If the name edit button does not exist yet, add content loaded listener to select the button
              if (!$nameBtn.length)
                  $scope.$on("$includeContentLoaded", clickBtn);
              else
                  clickBtn();
          }
      }
      

      
      $scope.$watch('selectedLog', function() {
         $location.search('editLog',
             $scope.selectedLog
                 ? $scope.selectedLog._links.self.href
                 : undefined)
          if (!$location.search()['editLog'])
          {
              $location
                  .search('editTemplate', null)
                  .search('editList', null)
          }
          $location.replace();
          $scope.initialLoad();
      });
      
	$scope.$on('$locationChangeSuccess', function()
	{
		if ($location.path() !== '/log-detail')
		{
			$location.search('editLog', null).replace();
			return;
		}
		
		var editLogVal = $location.search()['editLog'];

		if (editLogVal && (!$scope.selectedLog || $scope.selectedLog._links.self.href !== editLogVal))
		{
			logService.getLogs().subscribe(logs => {
				// Try and find log of the editing log value
				const log = logs.find(log => log._links.self.href == editLogVal);

				if (log)
				   logService.selectLog(log);
				else
					// If log does not exist from response, go to log selection
					$location.url('/logs');
			})
		}
		else if (!editLogVal)
			$scope.initialLoad();
	})
    
      $scope.deleteUser = function(user) {
         $http.delete(user._links.self.href).then(function() {
            if( $scope.isSelf(user) )
            {
               $location.$$search = {};
               $location.path('/');
               LogService.selectedLog = $rootScope.selectedLog = null;
            }
            else
               $scope.refreshUsers();
         });
      };
      
      $scope.deleteInvitation = function(invitation) {
         $http.delete(invitation._links.self.href).then(function() {
            $scope.refreshUsers();
         });
      }
      
      $scope.checkEmailExists = function()
      {
         var isEmail = typeof($scope.newUser.value) == 'string';
         $scope.emailExists = false;
         if( isEmail )
         {
            $scope.invitations.forEach(function(invitation) {
               if( $scope.newUser.value != null
                   && invitation.email != null
                   && $scope.newUser.value.toLowerCase() == invitation.email.toLowerCase() )
               {
                  $scope.emailExists = true;
               }
            });
         }
      }
      
      
      $scope.addUser = function() {
         if( $scope.emailExists )
            return;
         var d = $q.defer();
         var newUser = {
               "log" : $scope.selectedLog._links.self.href,
               "email" : typeof($scope.newUser.value) == 'string' ? $scope.newUser.value : null,
               "user" : $scope.newUser.value && typeof($scope.newUser.value) != 'string' 
                  ? $scope.newUser.value._links.self.href : null,
               "role" : $scope.newUser.role._links.self.href
         };
         if(!newUser.email && !newUser.user)
         {
            d.reject('error');
            $scope.newUserForm.$setError('email', 'User or email is required.');
            return d.promise;
         }
         $http.post('/api/logInvitations', newUser, {
            'noErrorPopup' : true,
            'rawError' : true
         }).then(function() {
            d.resolve();
            $scope.newUser.value = null;
            $scope.refreshUsers();
         }, function(errors) {
            handleFormError(d, $scope.newUserForm, errors);
         });
         return d.promise;
      };
      
      $scope.isSelf = function(user) {
         return $rootScope.user != null
            && user.isUser 
            && user.user.id === $rootScope.user.id;
      }
      
      $scope.isLastAdmin = function(user) {
         return $scope.numAdmins == 1 && $scope.mapRole(user.role) == 'ADMIN';
      }
      
      
      $scope.getPotentialUsers = function($viewValue)
      {
         return $http.get('/api/logBookUsers',
            {params: {
               nameLike: $viewValue,
               size: 50
            }}).then(function(data) {
            var currentUsers = $scope.users.map(function(user) {
               return user.user._links.self.href.replace(/\{.*\}/,'');
            });
            return $filter('filter')(data.data._embedded.logBookUsers,function(user) {
               return val = currentUsers.indexOf(user._links.self.href) < 0;
            });
         });
      };
      
      $scope.getActivityUrl = function(activity)
      {
         
         var param = {};
         param[activity.note ? 'note' : 'reminder'] = activity._links.self.href;
         return '/#/'+(activity.note ? 'note-detail' : 'reminder-detail')+'?'
            + $httpParamSerializer(param);
      }
      
      $scope.doDeleteLog = function()
      {
         if( $scope.deletionUpdate['confirmDeletion'] != 'confirm')
            throw new Error("Must confirm log deletion.");
         var deferred = $q.defer();
         $http.patch($scope.selectedLog._links.self.href, $scope.deletionUpdate)
            .then(function(result) {
               $scope.refreshLogs(result).then(function(result) {
                  delete $scope.deletionUpdate.confirmDeletion;
                  deferred.resolve();
               });
            });
         return deferred.promise;
      };
      
      $scope.doUndeleteLog = function()
      {
         var deferred = $q.defer();
         $http.patch($scope.selectedLog._links.self.href, $scope.unDeletionUpdate)
            .then(function(result) {
               $scope.refreshLogs(result).then(function(result) {
                  deferred.resolve();
               });
            });
         return deferred.promise;
      };
      
      $scope.refreshLogs = result => {
         const deferred = $q.defer();
         
         logService.getLogs().subscribe(logs => {
            logs.forEach(log => {
               if(result && result.data._links.self.href == log._links.self.href) {
                  $location.search('editLog', result.data._links.self.href);
                  
                  logDataService.getLogData(log).then(() => {
                     LogService.selectedLog = $rootScope.selectedLog = log;
                     $scope.readLogDeletionTime(log);
                     
                     deferred.resolve();
                  });
               }
            });
         });
         
         return deferred.promise;
      };

      $scope.updateLogField = function(field, data)
      {
         var config = {
            'noErrorPopup': true,
            'noValue': true};
         
         if( $scope.log._links )
         {
            var update = {};
            update[field] = (field == 'defaultReportObjectFilter' && data !== null) ? data.complexObject._links.self.href : data;
            var currentLog = $scope.selectedLog;
            return $http.patch($scope.log._links.self.href, update, config).then(function(results) {
               if( field == 'name')
                  currentLog.name = data;
               else if ( field == 'defaultReportObjectFilter') {
                   currentLog.defaultReportObjectFilter = $scope.reports.find(function(report)
                   {
                       return report.complexObject.id === results.data._embedded.defaultReportObjectFilter;
                   });
               }
            });
         }
         else
         {
            return $http.post('/api/logs', 
                  {'name': data,
                   'timeZone': moment.tz.guess() }, 
                  config).then(function(result) {
               logService.selectLog(result.data);
               $location.url('/notes').search('log', result.data.id);
            }, function(errors) {
               if( errors == 'Forbidden' )
                  errors = "You do not have permission to create new logs.  Your payment for LogBook may be expired.";
               return errors;
            });
         }
      };
      
      $scope.chartOptions = {
         chart: {
            type: 'lineChart',
            height: 150,
            margin : {
                top: 20,
                right: 20,
                bottom: 20,
                left: 20
            },
            x: function(d){ 
               return new Date(d.date); 
               },
            y: function(d){ 
               return d.value;
               },
            showValues: true,
            valueFormat: function(d){
                return d3.format(',.4f')(d);
            },
            transitionDuration: 500,
            xAxis: {
                axisLabel: 'Date',
                tickFormat: function(d) { return $filter('date')(new Date(d), 'MM-dd');}
            },
            yAxis: {
                axisLabel: 'Notes',
                axisLabelDistance: 30
            }
        },
        callback: function(chart) {
           console.log(chart);
        }
      };

      $scope.chartSliderOptions = {
         'from' : 7,
         'to' : 120,
         'step': 7,
         'skin': 'plastic',
         'css': {
            background: {"background-color": "silver"},
            before: {"background-color": "silver"},// zone before default value
            default: {"background-color": "silver"}, // default value: 1px
            after: {"background-color": "silver"},  // zone after default value
            pointer: {"background-color": "silver"},   // circle pointer
            range: {"background-color": "red"} // use it if double value
        },
        'callback' : function(value,released) {
           $scope.chartDays = value;
           $scope.refreshLogStatistics();
        }
         
      };

      $scope.updateNewNoteStyles = log => {
         return $http.patch(log._links.self.href, {
            'newNoteStyles' : $scope.selectedLog.newNoteStyles
         })
         .then(() => {
            logService.getLogs().subscribe(logs => {
               logs.forEach(log => {
                   if(log.id == $scope.selectedLog.id)
                     $scope.selectedLog.newNoteStyles = log.newNoteStyles;
               });
            });
         });
      }

      $scope.newConfigItem = {};
      
      $scope.logConfigDataTypes = [
         {'id':1, 'name':"Checkbox"},
         {'id':2, 'name':"One Line Text"},
         {'id':3, 'name':"Long Text"}
      ];
      
      $scope.getLogConfigHierarchies = function(logId)
      {
         return $http.get('/api/logConfigHierarchies', {
            params: {
               log: logId,
               size: 10000
            }
         });
      };

      $scope.loadConfigHierarchies = function(currentLog) {
         if( !currentLog ) {
             return;
         }

         return $scope.getLogConfigHierarchies(currentLog.id).then(function(result) {
             delete $scope.configHierarchies;
             $scope.hasConfig = false;

             result.data._embedded.logConfigHierarchies.forEach(function(hierarchy) {
                if(hierarchy.hierarchy.indexOf('logbook.webui') != 0 ) {
                    $scope.hasConfig = true;
                }
             });

            if ( !$scope.configs ) {
                $scope.configs = {};
            }

            result.data._embedded.logConfigHierarchies.forEach(function(hierarchy) {
               if( !$scope.configs[hierarchy.hierarchy] )
                  $scope.configs[hierarchy.hierarchy] = []
               //$scope.configs[hierarchy.hierarchy].push({});
            });

            $scope.configHierarchies = Object.keys($scope.configs);
            
            
            if( $scope.hasConfig && !(currentLog.role == 'ADMIN'))
            {
               return $http.get('/api/logConfigs', {
                  params: {
                     log: currentLog.id,
                     hierarchy: 'logbook.log_config.users',
                     value: $scope.user.id,
                     size: 10000
                  }
               }).then(function(result) {
                  $scope.isConfigEditor = result && result.data
                  && result.data._embedded && result.data._embedded.length > 0;
               });
            } else if ( currentLog.role == 'ADMIN' ) {
                $scope.isConfigEditor = true;
            }
         });
      };
      
      if( $scope.selectedLog )
         $scope.loadConfigHierarchies($scope.selectedLog);
      
    $scope.showConfigsLimit = 50;
    $scope.resetLimit = function() {
       $scope.showConfigsLimit = 50;
    };
    
    $scope.showMoreConfigs = function()
    {
       if( $scope.showMoreHandle )
          $timeout.cancel($scope.showMoreHandle);
       
       $scope.showMoreHandle = $timeout(function() {
          if( $scope.loadedHierarchy 
                && $scope.configs[$scope.loadedHierarchy]
                && $scope.configs[$scope.loadedHierarchy].length > $scope.showConfigsLimit )
          $scope.showConfigsLimit += 50;
       }, 30);
    }
  
    $scope.loadHierarchy = function(hierarchy, skipCloseCheck) {
       if( hierarchy == undefined )
       {
          $timeout(function() { $scope.newItemForm.$show() });
          return;
       }
       
       if( $scope.loadedHierarchy == hierarchy && !skipCloseCheck)
       {
          delete $scope.loadedHierarchy;
          delete $scope.configs[hierarchy];
          return;
       }
       return $http.get('/api/logConfigs', {
          params: {
             log: $scope.selectedLog.id,
             hierarchy: hierarchy,
             size: 10000
          }
       }).then(function(result) {
            
            $scope.configs[hierarchy] = [];
            result.data._embedded.logConfigs.forEach(function(config) {
               $scope.configs[config.hierarchy].push(config);
               if(config.dataType.id == 1)
               {
                  config.value = $scope.isTrue(config.value);
                  config.searchValue = config.value ? 'Yes' : 'No';
               }
               else
                  config.searchValue = config.value;
            });
            $scope.getYesNoItems(hierarchy);
            if( $scope.lastYesNoWatch )
               $scope.lastYesNoWatch();
            $scope.currentTableCtrl = $scope.smartTableCtrlContainer['table.'+hierarchy];
            $scope.lastYesNoWatch = $scope.$watch('currentTableCtrl.getFilteredCollection()', function() {
               $scope.getYesNoItems(hierarchy);
            }, true);
            $scope.loadedHierarchy = hierarchy;

       });
    };
      $scope.updateLogConfigField = function(logConfig, field, data) {
         var config = {
               'noErrorPopup': true,
               'noValue': true};
            
         var update = {};
         update[field] = data;
         return $http.patch(logConfig._links.self.href, update, config).then(function(result) {
            if(logConfig.dataType.id == 1)
               logConfig.searchValue = $scope.isTrue(data) ? 'Yes' : 'No';
         });
      };
      
      $scope.setNewConfigItemField = function(field, data) {
         $scope.newConfigItem[field] = data;
      };
      
      $scope.isTrue = function(value)
      {
         return (/^true$/i).test(value);
      };
      
      $scope.resetNewConfigItem = function()
      {
         $scope.newConfigItem = {};
         if( $scope.loadedHierarchy )
            $scope.newConfigItem['hierarchy'] = $scope.loadedHierarchy;
      };
      
      $scope.addNewConfigItem = function() 
      {
         var config = {
               'noErrorPopup': true,
               'rawError' : true,
               'noValue': true};
         var update = angular.extend({}, $scope.newConfigItem);
         update['log'] = $scope.selectedLog._links.self.href;
         if( update['dataType'] == 1 && !update['value'])
            update['value'] = 'false';
         if( update['dataType'])
            update['dataType'] = '/api/dataTypes/' + update['dataType'];
         var currentLog = $scope.selectedLog;
         var d = $q.defer();
         $http.post('/api/logConfigs', update, config).then(function(result) {
            $scope.loadConfigHierarchies(currentLog).then(function() {
               if( $scope.loadedHierarchy == update['hierarchy'])
               {
                  delete $scope.loadedHierarchy;
                  $scope.loadHierarchy(update['hierarchy']);
               }
               d.resolve();
            });
         }, function(errors) {
            handleFormError(d, $scope.newItemForm, errors);
         });
         return d.promise;
      }
      
      $scope.deleteConfig = function(config)
      {
         $http.delete(config._links.self.href).then(function() {
            $scope.configs[config.hierarchy].splice($scope.configs[config.hierarchy].indexOf(config), 1);
         })
      }
      
      $scope.forceShowConfig = $location.search()['forceShowConfig'] == 'Y';
      
      $scope.getYesNoItems = function(hierarchy)
      {
         return $timeout(function() {
            $scope.numYes=0;
            var ctrl = $scope.smartTableCtrlContainer['table.'+hierarchy];
            if( !ctrl )
               return [];
            var result = [];
            var col = ctrl.getFilteredCollection();
            for(var i=0; i < col.length; i++ )
            {
               if( col[i].dataType.id == 1 )
               {
                  result.push(col[i]);
                  if( $scope.isTrue(col[i].value))
                     $scope.numYes+=1;
               }
            }
            $scope.matchingItems[hierarchy] = result;
         });
      };
      
      $scope.bulkUpdateYesNo = function(hierarchy, $data)
      {
         var promises = [];
         for(var i=0; i < $scope.matchingItems[hierarchy].length; i++ )
         {
            var item = $scope.matchingItems[hierarchy][i];
            var update = {};
            update['value'] = $data;
            promises.push($http.patch(item._links.self.href, update));
         }
         return $q.all(promises).then(function() {
            $scope.loadHierarchy(hierarchy, true);
         });
      };
      
      $scope.refreshLogConfigs = function()
      {
         var currentLog = $scope.selectedLog;
         logDataService.getLogConfigs(currentLog).then(function(result) {
            $scope.enterNotesTurnoverOnly = currentLog.logConfigs['enterNotesTurnoverOnly'] == 'true';
            $scope.recentNotesTurnoverOnly = currentLog.logConfigs['recentNotesTurnoverOnly'] == 'true';
            $scope.enterNotesShowAcknowledgements = currentLog.logConfigs['enterNotesShowAcknowledgements'] == 'true';
            $scope.recentNotesShowAcknowledgements = currentLog.logConfigs['recentNotesShowAcknowledgements'] == 'true';
            $scope.defaultReportFilter = currentLog.logConfigs['defaultReportFilter'];
            $scope.defaultLogPage = currentLog.logConfigs['defaultLogPage'];
         });
      };
      $scope.refreshLogConfigs();
      
      $scope.updateLogConfig = function(configKey, $data, dataTypeId)
      {
         var configHref = $scope.selectedLog.logConfigHref[configKey]
         if(configHref)
         {
            return $http.patch(configHref, {'value':$data}).then($scope.refreshLogConfigs);
         }
         else
         {
            if( !dataTypeId )
               dataTypeId = 1;
            return $http.post('/api/logConfigs', {
                  'log': $scope.selectedLog._links.self.href,
                  'hierarchy': 'logbook.webui.config',
                  'key': configKey,
                  'dataType':'/api/dataTypes/'+dataTypeId,
                  'value': $data
            }).then($scope.refreshLogConfigs);
         }
      };
      
      $scope.getDeliveryChannelUpdates = function()
      {
          if (!$scope.selectedLog)
              return $q.reject('No Selected Log');
          
          return $http.get('/api/logNotificationDeliveryChannels', {
              noIndicator: true,
              params: {
                  log: $scope.selectedLog.id,
                  sort: 'created,desc'
              }
          })
              .then(function(results)
              {
                  $scope.fetchedChannelUpdates = true;
                  return $scope.deliveryChannelUpdates = results.data._embedded.logNotificationDeliveryChannels.map(function(status)
                  {
                      status.readableDate = moment(status.created).format('MM/D/YYYY HH:mm:ss')
                      status.viewString = status.readableDate + ' '
                          + status.createdBy.firstName + ' '
                          + status.createdBy.lastName + ' email '
                          + ((status.enabled)
                              ? 'ENABLED - ' + status.notificationsDelivered + ' emails delivered'
                              : 'DISABLED');
                      
                      return status;
                  });
              })
      }
      
      $scope.setEmailStatus = function(enabled)
      {
          var toPost = {
              log: $scope.selectedLog._links.self.href,
              enabled: !!enabled,
              channel: '/api/deliveryChannels/1'
          };
          
          return $http.post('/api/logNotificationDeliveryChannels', toPost, {
              noErrorPopup: true,
              rawError: true
          })
              .then(function()
              {
                  return $scope.getDeliveryChannelUpdates();
              })
              .catch(function(error)
              {
                  errorHandler.handle('An error occurred changing log email settings.', JSON.stringify(error), true);
              })
      }
      
      $scope.getEmailStatus = function()
      {
          var last = $scope.deliveryChannelUpdates[0];
          return (last && last.enabled)
      }
      
      $scope.getEmailCount = function()
      {
          var last = $scope.deliveryChannelUpdates[0];
          return (last) ? last.notificationsDelivered : 0;
      }
      
      $scope.showEmailModal = function()
      {
          var enabled = $scope.getEmailStatus();
          var modalInstance = uibModal.open({
			  template: require('./notification-email-confirm.html'),
              controller: ['$scope', function(scope)
              {
                  scope.emailEnabled = enabled;
              }],
              backdrop: 'static'
          })
          
          modalInstance.result
              .then(function()
              {
                  return $scope.setEmailStatus(!enabled)
                      .then(function()
                      {
                          $('.container.log-detail-container .email-well.well').scrollTop(0);
                      })
              })
      }
      
      $scope.toggleEmailHistoryView = function()
      {
          $scope.getDeliveryChannelUpdates();
          $scope.showEmailHistory = !$scope.showEmailHistory;
      }
      
      $scope.getDeliveryChannelUpdates();
      
      $http.get('/api/systemParameters', {
         params: {
            'nameLike': 'provisioning.%'
         }
      }).then(function(results) {
         $scope.provisioningData = {}; //results.data._embedded.systemParameters;
         results.data._embedded.systemParameters.forEach(function(param) {
            var productName = param.name.substring(param.name.indexOf('.')+1, param.name.lastIndexOf('.'));
            var dataKey = param.name.substring(param.name.lastIndexOf('.')+1);
            if(!$scope.provisioningData[productName])
               $scope.provisioningData[productName] = {};
            $scope.provisioningData[productName][dataKey] = param.value;
            if( param.name.endsWith('.paymentKey')
                  && $scope.selectedLog
                  && $scope.selectedLog.millisToFeatureExpiration[param.value] > 0)
            {
               $scope.hasProvisioning=true;
            }
            
         })
         
      });
      $scope.timeZones = {
            "America/New_York" : "Eastern",
            "America/Chicago": "Central",
            "America/Denver": "Mountain",
            "America/Phoenix": "Arizona",
            "America/Los_Angeles": "Pacific",
            "America/Anchorage": "Alaska",
            "America/Adak": "Aleutian",
            "Pacific/Honolulu": "Hawaii"
        };
      $scope.timezoneKeys = Object.keys($scope.timeZones);
      
      $scope.defaultLogPageChoices = [
            {'url':'notes', 'desc':'Enter Notes'},
            {'url':'notes?readOnlyView=Y', 'desc': 'Recent Notes'}
      ];
      
      if( $scope.selectedLog && $scope.selectedLog.sentinelProvisioned )
         $scope.defaultLogPageChoices.push({'url':'sentinel', 'desc': 'Sentinel'});
      
      if( $scope.selectedLog && $scope.selectedLog.onsiteEnabled && $scope.selectedLog.onsiteNumberProvisioned)
         $scope.defaultLogPageChoices.push({'url':'onsite', 'desc': 'OnSite'});
      
      $scope.getLogPageChoiceDescription = function(url) {
         var res = $scope.defaultLogPageChoices.filter(function(c) {
            return c.url == url;
         }).map(function(c) {
            return c.desc;
         });
         if( res.length )
            return res[0];
      };
        
      /**
       * Clears the specified query key from the query string.
       * @param {string} key The query key to clear.
       */
      $scope.clearQueryValue = (key) => {
        $location.search(key, null).replace();
      }

		$scope.toggleNoteDeletionEnabled = function($data) {
			AppStateService.setDeletionEnabledForLog($scope.selectedLog.id, $data);
		}
		
		$scope.getWeekAgoIsoString = function() {
			let dt = new Date();
			dt.setDate(dt.getDate() - 7);
			dt.setMilliseconds(0);
			dt.setSeconds(0);
			return dt.toISOString();
		};
		
		$scope.notAdmin = function(role) {
			return role.id !== 3;
		};
		
		$scope.doSimulateUserRole = function($data) {
			simulateLogUserRoleService.simulateLogUserRole(parseInt($scope.selectedLog.id), parseInt($data.id));
		};

		$scope.isAdmin = function() {
			return AppStateService.isAdmin;
		}

  }]);
